import * as React from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../../../redux';
import {change, getFormValues} from 'redux-form';
import View from './view';
import {Forms} from '../../../../../shared/models/forms';
import {getProductsFilterName} from '../../pipes';
import {ProductsCategoryFilterForm} from '../../model';
import {PropsProductCategoryList} from '../../model';

export const ProductCategoryFilterList: React.FC<PropsProductCategoryList> = (props) => {
  const filterProductsCategoryFormValues = useSelector(
    getFormValues(Forms.productsCategoryFilterForm),
  ) as ProductsCategoryFilterForm;
  const prevProductsCategoryFilterFormValues = React.useRef<boolean[]>(
    filterProductsCategoryFormValues?.productCategory ?? [],
  );
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    if (!filterProductsCategoryFormValues?.productCategory) {
      dispatch(change(Forms.productsCategoryFilterForm, getProductsFilterName(String(0), 'productCategory'), true));
      prevProductsCategoryFilterFormValues.current = [true];
    } else {
      const isAnySelected = filterProductsCategoryFormValues.productCategory.some((item, index) =>
        index ? item : false,
      );
      if (!prevProductsCategoryFilterFormValues.current[0] && filterProductsCategoryFormValues.productCategory[0]) {
        if (isAnySelected) dispatch(change(Forms.productsCategoryFilterForm, 'productCategory', [true]));
      } else {
        if (isAnySelected) {
          if (filterProductsCategoryFormValues.productCategory[0])
            dispatch(
              change(Forms.productsCategoryFilterForm, getProductsFilterName(String(0), 'productCategory'), false),
            );
        } else {
          if (!filterProductsCategoryFormValues.productCategory[0])
            dispatch(
              change(Forms.productsCategoryFilterForm, getProductsFilterName(String(0), 'productCategory'), true),
            );
        }
      }
      prevProductsCategoryFilterFormValues.current = filterProductsCategoryFormValues.productCategory;
    }
  }, [filterProductsCategoryFormValues]);
  return <View {...props} />;
};
